/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GrantLocaleConsentRequest} from '@cash-web/protos/squareup/cash/cashcustomerprofile/api/v1/grant_locale_consent.pb'
import {GrantLocaleConsentResponse} from '@cash-web/protos/squareup/cash/cashcustomerprofile/api/v1/grant_locale_consent.pb'


export const grantLocaleConsent = (request: GrantLocaleConsentRequest, options?: CashRequestOptions) => post<GrantLocaleConsentRequest, GrantLocaleConsentResponse>("/2.0/cash/grant-locale-consent", request, {...options, rejectOnError: true })